import { useFormikContext } from "formik";
import {
  SummaryTable,
  SummaryTableRow,
} from "@poseidon/ui/components/SummaryTable";
import { formatCurrency } from "@poseidon/utils/currency";
import Button from "@mui/material/Button";
import React from "react";
import { Chip, LinearProgress } from "@mui/material";
import { usePermissions } from "@poseidon/ui/components";

export const RequotePreview = ({ data, onApply, saving, loading }) => {
  const { canWrite } = usePermissions();
  const { values } = useFormikContext();
  return (
    <>
      {data.fixedRate && (
        <Chip label="Fixed rate" color="info" sx={{ mb: 2 }} />
      )}
      <SummaryTable>
        <SummaryTableRow label="APR">{data.apr}%</SummaryTableRow>
        <SummaryTableRow label="Annual Rate">
          {data.annualRate}%
        </SummaryTableRow>
        <SummaryTableRow label="Base Rate">{data.baseRate}%</SummaryTableRow>
        <SummaryTableRow label="Addon Rate">{data.addonRate}%</SummaryTableRow>
        <SummaryTableRow label="Cost of Vessel">
          {formatCurrency(data.costOfVessel)}
        </SummaryTableRow>
        <SummaryTableRow label="Deposit">
          {formatCurrency(data.deposit)}
        </SummaryTableRow>
        <SummaryTableRow label="Loan Amount">
          {formatCurrency(data.principal)}
        </SummaryTableRow>
        <SummaryTableRow label="Term">
          {Math.ceil(data.term)} months
        </SummaryTableRow>
        {data.balloon > 0 && (
          <SummaryTableRow label="Balloon">
            {formatCurrency(data.balloon, true)}
          </SummaryTableRow>
        )}
        <SummaryTableRow label="Payments">
          <ul>
            {data.payments.map((payment, index) => (
              <li key={index}>
                {payment.count} &times;{" "}
                {formatCurrency(Math.abs(payment.amount), true)}
              </li>
            ))}
          </ul>
        </SummaryTableRow>
        <SummaryTableRow label="Total Payable">
          {formatCurrency(data.totalPayable, true)}
        </SummaryTableRow>
        <SummaryTableRow label="Cost of Credit">
          {formatCurrency(data.costOfCredit)}
        </SummaryTableRow>
      </SummaryTable>
      <Button
        variant="contained"
        onClick={() => onApply(values)}
        margin="normal"
        color="error"
        disabled={loading || saving || !canWrite}
        sx={{ mt: 3 }}
      >
        Apply Quote
      </Button>
      {saving && <LinearProgress sx={{ mt: 2 }} />}
    </>
  );
};
